<!-- Sidebar -->
<div class="sidebar" id="sidebar">
  <div class="ribbone-card">
    <div
      *ngIf="(subscription$ | async)?.subscriptionStatus === SubscriptionStatus.Trialing"
      class="ribbone ribbone-top-left text-primary"
    >
      <span class="bg-primary">Trial</span>
    </div>
    <!-- Logo -->
    <div class="sidebar-logo">
      <a [routerLink]="[getDashboardRoute()]" class="logo logo-normal">
        <img src="assets/img/logo/logo.webp" alt="Logo" />
      </a>
      <a [routerLink]="[getDashboardRoute()]" class="logo-small">
        <img src="assets/img/logo/logo-small.webp" alt="Logo" />
      </a>
      <a [routerLink]="[getDashboardRoute()]" class="dark-logo">
        <img src="assets/img/logo/logo-white.webp" alt="Logo" />
      </a>
    </div>
    <!-- /Logo -->
  </div>

  <div class="modern-profile p-3 pb-0">
    <div class="text-center rounded bg-light p-3 mb-4 user-profile">
      <div class="avatar avatar-lg online mb-3">
        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle" />
      </div>
      <h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
      <p class="fs-10">System Admin</p>
    </div>
    <div class="sidebar-nav mb-3">
      <ul
        class="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
        role="tablist"
      >
        <li class="nav-item"><a class="nav-link active border-0" href="#">Menu</a></li>
        <li class="nav-item"><a class="nav-link border-0" href="chat.html">Chats</a></li>
        <li class="nav-item"><a class="nav-link border-0" href="email.html">Inbox</a></li>
      </ul>
    </div>
  </div>
  <div class="sidebar-header p-3 pb-0 pt-2">
    <div class="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
      <div class="avatar avatar-md onlin">
        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle" />
      </div>
      <div class="text-start sidebar-profile-info ms-2">
        <h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
        <p class="fs-10">System Admin</p>
      </div>
    </div>
    <div class="input-group input-group-flat d-inline-flex mb-4">
      <span class="input-icon-addon">
        <i class="ti ti-search"></i>
      </span>
      <input type="text" class="form-control" placeholder="Search in HRMS" />
      <span class="input-group-text">
        <kbd>CTRL + / </kbd>
      </span>
    </div>
    <div class="d-flex align-items-center justify-content-between menu-item mb-3">
      <div class="me-3">
        <a href="calendar.html" class="btn btn-menubar">
          <i class="ti ti-layout-grid-remove"></i>
        </a>
      </div>
      <div class="me-3">
        <a href="chat.html" class="btn btn-menubar position-relative">
          <i class="ti ti-brand-hipchat"></i>
          <span
            class="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span
          >
        </a>
      </div>
      <div class="me-3 notification-item">
        <a href="activity.html" class="btn btn-menubar position-relative me-1">
          <i class="ti ti-bell"></i>
          <span class="notification-status-dot"></span>
        </a>
      </div>
      <div class="me-0">
        <a href="email.html" class="btn btn-menubar">
          <i class="ti ti-message"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- 🔥 SCROLLABLE MENU -->
  <div class="sidebar-menu-wrapper">
    <div class="sidebar-menu-inner">
      <div
        class="slimScrollDiv"
        style="
          position: relative;
          overflow-y: auto;
          overflow-x: hidden; /* optional */
          width: 100%;
          /* height: 90vh; */
          height: 100%;
          margin-top: 10px;
        "
      >
        <div
          class="sidebar-inner slimscroll"
          style="overflow-y: auto; overflow-x: hidden; /* optional */ width: 100%; height: 100%"
        >
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li class="menu-title" *ngIf="!isSubscriptionExpired"><span>MAIN MENU</span></li>
              <li *ngIf="!isSubscriptionExpired">
                <ul>
                  <!-- <li class="submenu">
                    <a
                      href="javascript:void(0);"
                      (click)="toggleSubMenu($event, 0)"
                      [ngClass]="{ subdrop: subMenuStates[0], active: isDashboardActive }"
                    >
                      <i class="ti ti-smart-home"></i>
                      <span>Dashboard</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul
                      [ngClass]="{ 'd-none': !subMenuStates[0] }"
                      [ngStyle]="{ display: subMenuStates[0] ? 'block' : 'none' }"
                    >
                      <li *appHasPermission="{ dashboard: ['view'] }">
                        <a
                          [ngClass]="{ active: currentRoute === eps.user.dashboardPath }"
                          [routerLink]="eps.user.dashboardPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Admin Dashboard</a
                        >
                      </li> -->
                  <!-- <li
                    *appHasPermission="[{ employeeDashboard: ['view'] }, { dashboard: ['view'] }]"
                  > -->
                  <!-- <li>
                        <a
                          [ngClass]="{ active: currentRoute === eps.user.employeeDashboardPath }"
                          [routerLink]="eps.user.employeeDashboardPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="!isAdmin"
                          >Employee Dashboard</a
                        >
                      </li>
                      <li *ngIf="isBusinessOwner">
                        <a
                          [ngClass]="{ active: currentRoute === eps.user.ownerDashboardPath }"
                          [routerLink]="eps.user.ownerDashboardPath"
                          routerLinkActive="active"
                          (click)="closeSidebarOverlay()"
                          [routerLinkActiveOptions]="{ exact: true }"
                          *ngIf="!isAdmin"
                        >
                          Owner Dashboard
                        </a>
                      </li>
                    </ul>
                  </li> -->
                  <!-- Business Owner -->
                  <ng-container *ngIf="!isSubscriptionExpired">
                    <li class="submenu" *ngIf="isBusinessOwner && !isAdmin">
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 0)"
                        [ngClass]="{ subdrop: subMenuStates[0], active: isDashboardActive }"
                      >
                        <i class="ti ti-smart-home"></i>
                        <span>Dashboard</span>
                        <span class="menu-arrow"></span>
                      </a>

                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[0] }"
                        [ngStyle]="{ display: subMenuStates[0] ? 'block' : 'none' }"
                      >
                        <li>
                          <a
                            [ngClass]="{ active: currentRoute === eps.user.employeeDashboardPath }"
                            [routerLink]="eps.user.employeeDashboardPath"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="closeSidebarOverlay()"
                          >
                            Employee Dashboard
                          </a>
                        </li>

                        <li *appHasPermission="{ ownerDashboard: ['view'] }">
                          <a
                            [ngClass]="{ active: currentRoute === eps.user.ownerDashboardPath }"
                            [routerLink]="eps.user.ownerDashboardPath"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="closeSidebarOverlay()"
                          >
                            Owner Dashboard
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ng-container>
                  <!-- Admin -->
                  <li *ngIf="isAdmin">
                    <a
                      [ngClass]="{ active: currentRoute === eps.user.dashboardPath }"
                      [routerLink]="eps.user.dashboardPath"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="closeSidebarOverlay()"
                    >
                      <i class="ti ti-smart-home"></i>
                      <span>Dashboard</span>
                    </a>
                  </li>

                  <!-- Employee -->
                  <ng-container *ngIf="!isSubscriptionExpired">
                    <li *ngIf="!isAdmin && !isBusinessOwner">
                      <a
                        [ngClass]="{ active: currentRoute === eps.user.employeeDashboardPath }"
                        [routerLink]="eps.user.employeeDashboardPath"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="closeSidebarOverlay()"
                      >
                        <i class="ti ti-smart-home"></i>
                        <span>Dashboard</span>
                      </a>
                    </li>
                  </ng-container>
                  <li class="submenu" *ngIf="isAdmin">
                    <a
                      href="javascript:void(0);"
                      (click)="toggleSubMenu($event, 6)"
                      [ngClass]="{ subdrop: subMenuStates[6], active: isSuperAdminActive }"
                    >
                      <i class="ti ti-user-star"></i>
                      <span>Super Admin</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul
                      [ngClass]="{ 'd-none': !subMenuStates[6] }"
                      [ngStyle]="{ display: subMenuStates[6] ? 'block' : 'none' }"
                    >
                      <li *appHasPermission="{ plans: ['add', 'edit', 'delete'] }">
                        <a
                          [ngClass]="{ active: currentRoute === eps.superAdmin.plansPath }"
                          [routerLink]="eps.superAdmin.plansPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Plans</a
                        >
                      </li>
                      <li *appHasPermission="{ subscribers: ['view', 'add', 'edit', 'delete'] }">
                        <a
                          [ngClass]="{ active: currentRoute === eps.superAdmin.subscribersPath }"
                          [routerLink]="eps.superAdmin.subscribersPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Subscribers</a
                        >
                      </li>
                      <li>
                        <a
                          [ngClass]="{ active: currentRoute === eps.superAdmin.couponsPath }"
                          [routerLink]="eps.superAdmin.couponsPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Coupons</a
                        >
                      </li>
                      <li>
                        <a
                          [ngClass]="{ active: currentRoute === eps.superAdmin.cronPath }"
                          [routerLink]="eps.superAdmin.cronPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Cron Jobs</a
                        >
                      </li>

                      <li>
                        <a
                          [ngClass]="{
                            active:
                              currentRoute === eps.notificationCampaign.base ||
                              currentRoute.startsWith('/' + eps.notificationCampaign.base + '/')
                          }"
                          [routerLink]="eps.notificationCampaign.base"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: false }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Notification Campaigns</a
                        >
                      </li>

                      <li>
                        <a
                          [ngClass]="{
                            active: currentRoute === 'earnings'
                          }"
                          routerLink="/earnings"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: false }"
                          (click)="closeSidebarOverlay()"
                          *ngIf="isAdmin"
                          >Earnings</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <ng-container *ngIf="!isSubscriptionExpired">
                <li
                  *appHasPermission="[
                    { business: ['view'] },
                    { department: ['view'] },
                    { designation: ['view'] },
                    { leavePolicy: ['view'] },
                    { attendancePolicy: ['view'] },
                    { earnings: ['view'] },
                    { customEarnings: ['view'] },
                    { customDeductions: ['view'] },
                    { reimbursements: ['view'] },
                    { statutoryDeductions: ['view'] }
                  ]"
                  class="menu-title"
                >
                  <span>Companies</span>
                </li>
                <li>
                  <ul>
                    <li
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: false }"
                      *appHasPermission="{ business: ['view'] }"
                      #rla="routerLinkActive"
                    >
                      <a [routerLink]="eps.company.businessPath" (click)="closeSidebarOverlay()">
                        <i class="ti ti-building" [class.text-primary]="rla.isActive"></i
                        ><span>Business Entities</span>
                      </a>
                    </li>
                    <li
                      class="submenu"
                      *appHasPermission="[
                        { department: ['view'] },
                        { designation: ['view'] },
                        { leavePolicy: ['view'] },
                        { attendancePolicy: ['view'] },
                        { earnings: ['view'] },
                        { customEarnings: ['view'] },
                        { customDeductions: ['view'] },
                        { reimbursements: ['view'] },
                        { statutoryDeductions: ['view'] }
                      ]"
                    >
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 1)"
                        [ngClass]="{ subdrop: subMenuStates[1], active: isSetupActive }"
                      >
                        <i class="ti ti-settings"></i><span>Setup</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[1] }"
                        [ngStyle]="{ display: subMenuStates[1] ? 'block' : 'none' }"
                      >
                        <li *appHasPermission="{ department: ['view'] }">
                          <a
                            routerLink="/company/department"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{ active: currentRoute === 'company/department' }"
                            (click)="closeSidebarOverlay()"
                            >Departments</a
                          >
                        </li>
                        <li *appHasPermission="{ designation: ['view'] }">
                          <a
                            [routerLink]="['/company/designation']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{ active: currentRoute === 'company/designation' }"
                            (click)="closeSidebarOverlay()"
                            >Designations</a
                          >
                        </li>
                        <li *appHasPermission="{ leavePolicy: ['view'] }">
                          <a
                            [routerLink]="eps.leaves.policiesPath"
                            [ngClass]="{
                              active:
                                currentRoute === eps.leaves.policiesPath ||
                                currentRoute === eps.leaves.assignedPolicyDetailPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Leave Policies</a
                          >
                        </li>
                        <!-- <ng-container *appHasModule="'clockIn'">
                          <li *appHasPermission="{ attendancePolicy: ['view'] }">
                            <a
                              [routerLink]="eps.attendance.policiesPath"
                              [ngClass]="{
                                active:
                                  currentRoute === eps.attendance.policiesPath ||
                                  currentRoute === eps.attendance.attendancePolicyDetailsPath
                              }"
                              (click)="closeSidebarOverlay()"
                              >Attendance Policies</a
                            >
                          </li>
                        </ng-container> -->
                        <ng-container *ngIf="isAdmin; else nonAdminAttendancePolicy">
                          <li>
                            <a
                              [routerLink]="eps.attendance.policiesPath"
                              [ngClass]="{
                                active:
                                  currentRoute === eps.attendance.policiesPath ||
                                  currentRoute === eps.attendance.attendancePolicyDetailsPath
                              }"
                              (click)="closeSidebarOverlay()"
                              >Attendance Policies</a
                            >
                          </li>
                        </ng-container>

                        <ng-template #nonAdminAttendancePolicy>
                          <ng-container *appHasModule="'clockIn'">
                            <li *appHasPermission="{ attendancePolicy: ['view'] }">
                              <a
                                [routerLink]="eps.attendance.policiesPath"
                                [ngClass]="{
                                  active:
                                    currentRoute === eps.attendance.policiesPath ||
                                    currentRoute === eps.attendance.attendancePolicyDetailsPath
                                }"
                                (click)="closeSidebarOverlay()"
                                >Attendance Policies</a
                              >
                            </li>
                          </ng-container>
                        </ng-template>
                        <li
                          *appHasPermission="[
                            { earnings: ['view'] },
                            { customEarnings: ['view'] },
                            { customDeductions: ['view'] },
                            { reimbursements: ['view'] },
                            { statutoryDeductions: ['view'] }
                          ]"
                        >
                          <a
                            [routerLink]="eps.company.salaryComponentsPath"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{
                              active: currentRoute === eps.company.salaryComponentsPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Salary Components</a
                          >
                        </li>
                        <li *appHasPermission="[{ taxSlabs: ['view'] }, { taxRules: ['view'] }]">
                          <a
                            [routerLink]="eps.company.taxSettingsPath"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{ active: currentRoute === eps.company.taxSettingsPath }"
                            (click)="closeSidebarOverlay()"
                            >Tax Settings</a
                          >
                        </li>
                        <li *appHasPermission="{ role: ['view'] }">
                          <a
                            [routerLink]="eps.role.rolePath"
                            [ngClass]="{
                              active:
                                currentRoute === eps.role.rolePath ||
                                currentRoute === eps.role.roleDetailsPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Roles</a
                          >
                        </li>
                        <!-- <li *appHasPermission="{ userRole: ['view'] }">
                          <a
                            routerLink="/userRole/role"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{ active: currentRoute === 'userRole/role' }"
                            (click)="closeSidebarOverlay()"
                            >User Roles</a
                          >
                        </li> -->
                        <li *appHasPermission="{ permissionSet: ['view'] }">
                          <a
                            [routerLink]="eps.permissionSet.permissionSetPath"
                            [ngClass]="{
                              active:
                                currentRoute === eps.permissionSet.permissionSetPath ||
                                currentRoute === eps.permissionSet.permissionSetdetailsPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Permission Sets</a
                          >
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ng-container>
              <li class="menu-title" *ngIf="!isSubscriptionExpired"><span>HRM</span></li>
              <li>
                <ul>
                  <ng-container *ngIf="!isSubscriptionExpired">
                    <li class="submenu" *appHasPermission="{ employees: ['view'] }">
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 2)"
                        [ngClass]="{ subdrop: subMenuStates[2], active: isEmployeeActive }"
                      >
                        <i class="ti ti-users"></i><span>Employees</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[2] }"
                        [ngStyle]="{ display: subMenuStates[2] ? 'block' : 'none' }"
                      >
                        <li>
                          <a
                            href="javascript:void(0);"
                            [ngClass]="{ active: currentRoute === eps.hrm.employeePath }"
                            [routerLink]="eps.hrm.employeePath"
                            routerLinkActive="active"
                            *appHasPermission="{ employees: ['view'] }"
                            (click)="closeSidebarOverlay()"
                            >Employees</a
                          >
                        </li>
                      </ul>
                    </li>

                    <li
                      class="submenu"
                      *appHasPermission="[{ attendance: ['view'] }, { attendanceAdmin: ['view'] }]"
                    >
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 3)"
                        [ngClass]="{ subdrop: subMenuStates[3], active: isAttendanceActive }"
                      >
                        <i class="ti ti-file-time"></i><span>Attendance</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[3] }"
                        [ngStyle]="{ display: subMenuStates[3] ? 'block' : 'none' }"
                      >
                        <li *appHasPermission="{ attendanceAdmin: ['view'] }">
                          <a
                            [routerLink]="eps.attendance.attendanceListPath"
                            [ngClass]="{
                              active: currentRoute === eps.attendance.attendanceListPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Attendance (Admin)</a
                          >
                        </li>
                        <li *appHasPermission="[{ attendance: ['view'] }]">
                          <a
                            [routerLink]="eps.attendance.calanderPath"
                            routerLinkActive="active"
                            [ngClass]="{ active: currentRoute === eps.attendance.calanderPath }"
                            (click)="closeSidebarOverlay()"
                            >Attendance (Employee)</a
                          >
                        </li>
                      </ul>
                    </li>

                    <li
                      class="submenu"
                      *appHasPermission="[
                        { leaves: ['view'] },
                        { holidays: ['view'] },
                        { leaveRequests: ['view'] },
                        { leaveBalance: ['view'] }
                      ]"
                    >
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 4)"
                        [ngClass]="{ subdrop: subMenuStates[4], active: isLeavesActive }"
                      >
                        <i class="ti ti-calendar-event"></i><span>Leaves</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[4] }"
                        [ngStyle]="{ display: subMenuStates[4] ? 'block' : 'none' }"
                      >
                        <li *appHasPermission="{ holidays: ['view'] }">
                          <a
                            [routerLink]="eps.leaves.holidaysPath"
                            [ngClass]="{ active: currentRoute === eps.leaves.holidaysPath }"
                            (click)="closeSidebarOverlay()"
                            >Holidays</a
                          >
                        </li>
                        <!-- <ng-container *appHasModule="'leaves'"> -->
                        <li *appHasPermission="{ leaves: ['view'] }">
                          <a
                            [routerLink]="eps.leaves.appliedLeavePath"
                            [ngClass]="{ active: currentRoute === eps.leaves.appliedLeavePath }"
                            (click)="closeSidebarOverlay()"
                            *ngIf="!isAdmin"
                            >My Leaves</a
                          >
                        </li>
                        <li *appHasPermission="{ leaveRequests: ['view'] }">
                          <a
                            [routerLink]="eps.leaves.leavesRequestPath"
                            [ngClass]="{ active: currentRoute === eps.leaves.leavesRequestPath }"
                            (click)="closeSidebarOverlay()"
                            >Leave Requests</a
                          >
                        </li>
                        <li>
                          <a
                            [routerLink]="eps.leaves.assignedPolicyBalancePath"
                            [ngClass]="{
                              active: currentRoute === eps.leaves.assignedPolicyBalancePath
                            }"
                            *appHasPermission="{ leaveBalance: ['view'] }"
                            (click)="closeSidebarOverlay()"
                            >Leave Balance</a
                          >
                        </li>
                        <!-- </ng-container> -->
                      </ul>
                    </li>
                    <!-- <li
                      class="submenu"
                      *appHasPermission="[{ payroll: ['view'] }, { payslip: ['view'] }]"
                    > -->
                    <li class="submenu" *appHasPermission="[{ payroll: ['view'] }]">
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 5)"
                        [ngClass]="{ subdrop: subMenuStates[5], active: isPayrollActive }"
                      >
                        <i class="ti ti-calculator"></i><span>Payroll</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[5] }"
                        [ngStyle]="{ display: subMenuStates[5] ? 'block' : 'none' }"
                      >
                        <li *appHasPermission="{ payroll: ['add', 'edit', 'delete'] }">
                          <a
                            [routerLink]="eps.hrm.managePayrollPath"
                            [ngClass]="{
                              active:
                                currentRoute === eps.hrm.managePayrollPath ||
                                currentRoute === eps.hrm.runPayrollPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Manage Payroll</a
                          >
                        </li>
                        <li *appHasPermission="{ contractor: ['view'] }">
                          <a
                            [routerLink]="eps.hrm.manageContractorPayrollPath"
                            [ngClass]="{
                              active: currentRoute === eps.hrm.manageContractorPayrollPath
                            }"
                            (click)="closeSidebarOverlay()"
                            >Manage Contractor Payroll</a
                          >
                        </li>
                        <li *appHasPermission="{ contractor: ['view'] }">
                          <a
                            [routerLink]="eps.hrm.investmentsPath"
                            [ngClass]="{ active: currentRoute === eps.hrm.investmentsPath }"
                            (click)="closeSidebarOverlay()"
                            >Investments</a
                          >
                        </li>
                        <li *appHasPermission="{ payslip: ['view'] }">
                          <a
                            [routerLink]="eps.hrm.payslipPath"
                            [ngClass]="{ active: currentRoute === eps.hrm.payslipPath }"
                            (click)="closeSidebarOverlay()"
                            >Payslip</a
                          >
                        </li>
                        <li *appHasPermission="{ invoice: ['view'] }">
                          <a
                            [routerLink]="eps.hrm.invoicePath"
                            [ngClass]="{ active: currentRoute === eps.hrm.invoicePath }"
                            (click)="closeSidebarOverlay()"
                            >Invoice</a
                          >
                        </li>
                      </ul>
                    </li>
                    <li *appHasPermission="{ payslip: ['view'] }" [hidden]="isBusinessOwner">
                      <a
                        [routerLink]="eps.hrm.payslipPath"
                        [ngClass]="{ active: currentRoute === eps.hrm.payslipPath }"
                        (click)="closeSidebarOverlay()"
                      >
                        <i class="ti ti-file-invoice"></i><span>Payslip</span>
                      </a>
                    </li>
                    <!-- <li
                      [ngClass]="{ active: currentRoute === eps.user.employeeRequestPath }"
                      *appHasPermission="{ requests: ['view'] }"
                    >
                      <a
                        [routerLink]="eps.user.employeeRequestPath"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [ngClass]="{ active: currentRoute === eps.user.employeeRequestPath }"
                        (click)="closeSidebarOverlay()"
                      >
                        <i class="ti ti-file-time"></i><span>Requests</span>
                      </a>
                    </li> -->
                    <li
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      [ngClass]="{ active: currentRoute === eps.user.employeeRequestPath }"
                      *appHasPermission="{ requests: ['view'] }"
                      #rla="routerLinkActive"
                    >
                      <a
                        [routerLink]="eps.user.employeeRequestPath"
                        (click)="closeSidebarOverlay()"
                      >
                        <i class="ti ti-file-time"></i><span>Requests</span>
                      </a>
                    </li>
                    <li class="submenu" *appHasPermission="{ event: ['view'] }">
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 8)"
                        [ngClass]="{ subdrop: subMenuStates[8], active: isEventsActive }"
                      >
                        <i class="ti ti-calendar-event"></i>
                        <span>Events</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[8] }"
                        [ngStyle]="{ display: subMenuStates[8] ? 'block' : 'none' }"
                      >
                        <li *appHasPermission="{ event: ['view'] }">
                          <a
                            [ngClass]="{ active: currentRoute === eps.event.birthdaysPath }"
                            [routerLink]="eps.event.birthdaysPath"
                            (click)="closeSidebarOverlay()"
                            >Birthdays</a
                          >
                        </li>
                        <li *appHasPermission="{ event: ['view'] }">
                          <a
                            [ngClass]="{ active: currentRoute === eps.event.anniversaryPath }"
                            [routerLink]="eps.event.anniversaryPath"
                            (click)="closeSidebarOverlay()"
                            >Anniversaries</a
                          >
                        </li>
                      </ul>
                    </li>
                    <li
                      [ngClass]="{ active: currentRoute === eps.user.orgChartPath }"
                      *appHasPermission="{ orgChart: ['view'] }"
                    >
                      <a
                        [routerLink]="eps.user.orgChartPath"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="closeSidebarOverlay()"
                      >
                        <i class="ti ti-sitemap"></i><span>Org Chart</span>
                      </a>
                    </li>
                  </ng-container>
                  <ng-container *ngIf="!isAdmin">
                    <li class="submenu" *appHasPermission="{ plansAndBilling: ['view'] }">
                      <a
                        href="javascript:void(0);"
                        (click)="toggleSubMenu($event, 7)"
                        [ngClass]="{ subdrop: subMenuStates[7], active: isPlansAndBillingActive }"
                      >
                        <i class="ti ti-user-star"></i>
                        <span>Plan and billing</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <ul
                        [ngClass]="{ 'd-none': !subMenuStates[7] }"
                        [ngStyle]="{ display: subMenuStates[7] ? 'block' : 'none' }"
                      >
                        <li
                          *appHasPermission="{ plansAndBilling: ['view'] }"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: false }"
                        >
                          <a
                            [ngClass]="{
                              active:
                                currentRoute === eps.planAndBilling.planPath ||
                                currentRoute === eps.planAndBilling.upgradePlanPath ||
                                currentRoute === eps.planAndBilling.activatePlanPath
                            }"
                            [routerLink]="eps.planAndBilling.planPath"
                            (click)="closeSidebarOverlay()"
                            >Plan</a
                          >
                        </li>
                        <li *appHasPermission="{ plansAndBilling: ['view'] }">
                          <a
                            [ngClass]="{ active: currentRoute === eps.planAndBilling.billingPath }"
                            [routerLink]="eps.planAndBilling.billingPath"
                            (click)="closeSidebarOverlay()"
                            >Billing</a
                          >
                        </li>
                        <!--<li *appHasPermission="{ plansAndBilling: ['view', 'add', 'edit', 'delete'] }">
                        <a
                          [ngClass]="{ active: currentRoute === eps.superAdmin.plansPath }"
                          [routerLink]="eps.superAdmin.plansPath"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="closeSidebarOverlay()"
                          >Payment Method</a
                        >
                      </li>-->
                      </ul>
                    </li>
                  </ng-container>
                  <li
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [ngClass]="{ active: currentRoute === eps.userLoginHistory.listPath }"
                    #rla="routerLinkActive"
                  >
                    <a [routerLink]="eps.userLoginHistory.listPath" (click)="closeSidebarOverlay()">
                      <i class="ti ti-file-time"></i><span>Login History</span>
                    </a>
                  </li>
                  <!-- <li class="submenu" *appHasPermission="{ userRole: ['view'] }">
              <a
                href="javascript:void(0);"
                (click)="toggleSubMenu($event, 5)"
                [ngClass]="{ subdrop: subMenuStates[5] }"
              >
                <i class="ti ti-users"></i><span>User Management</span>
                <span class="menu-arrow"></span>
              </a>
              <ul
                [ngClass]="{ 'd-none': !subMenuStates[5] }"
                [ngStyle]="{ display: subMenuStates[5] ? 'block' : 'none' }"
              >
                <li *appHasPermission="{ userRole: ['view'] }">
                  <a
                    routerLink="/userRole/role"
                    [ngClass]="{ active: currentRoute === 'userRole/role' }"
                    >Roles & Permission</a
                  >
                </li>
              </ul>
            </li> -->
                </ul>
              </li>
              <li class="menu-title d-none"><span>RECRUITMENT</span></li>
              <li class="d-none">
                <ul>
                  <li
                    [ngClass]="{ active: currentRoute === 'joblist' }"
                    *appHasPermission="{ jobs: ['view'] }"
                  >
                    <a
                      routerLink="/joblist"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                    >
                      <i class="ti ti-timeline"></i><span>Jobs</span>
                    </a>
                  </li>
                  <li
                    [ngClass]="{ active: currentRoute === 'candidatelist' }"
                    *appHasPermission="{ candidate: ['view'] }"
                  >
                    <a
                      routerLink="/candidatelist"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                    >
                      <i class="ti ti-user-shield"></i><span>Candidates</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="slimScrollBar"
          style="
            background: rgb(204, 204, 204);
            width: 7px;
            position: absolute;
            top: 0px;
            opacity: 0.4;
            display: none;
            border-radius: 7px;
            z-index: 99;
            right: 1px;
            height: 45.4015px;
          "
        ></div>
        <div
          class="slimScrollRail"
          style="
            width: 7px;
            height: 100%;
            position: absolute;
            top: 0px;
            display: none;
            border-radius: 7px;
            background: rgb(51, 51, 51);
            opacity: 0.2;
            z-index: 90;
            right: 1px;
          "
        ></div>
      </div>
    </div>
  </div>

  <!-- 🔥 FIXED BOTTOM LOGO -->
  <div class="sidebar-footer">
    <!-- <img src="assets/img/logo.webp" alt="logo" /> -->
    <a [routerLink]="[getDashboardRoute()]" class="logo logo-normal">
      <img src="assets/img/logo/logo.webp" alt="Logo" />
    </a>
  </div>
  <!-- /Sidebar -->
</div>
